import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';

export default function UpSpinner() {
    return (
        <div className="w-full md:w-12 flex flex-column align-items-center justify-content-center gap-3 py-5" >
            <ProgressSpinner style={{width: '50px', height: '50px' , backgroundColor : 'lightblue'}} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
        </div>
    );
}